import React, {useEffect, useState} from "react";
import Loader from "../../../components/Loader";
import HourlyRatesTable from "./HourlyRatesTable";
import adminRates from "../../../api/adminRates";

export default function HourlyRatesTableHandler() {
    //get data from api
    const [hourlyRate, setHourlyRate] = useState([]);

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        const response = await adminRates.getAllRates();
        if (response.ok) {
            setHourlyRate(response.data);
        }
    };

    //laat tabel zien met gegevens via props
    if (hourlyRate.length > 0) return <HourlyRatesTable reload={getData} hourlyRate={hourlyRate}/>;
    return <Loader/>
}
